import styled from 'styled-components';

const StyledWrapper = styled.div`
  width: 100%;
  margin-top: 20px;
`;

const StyledImg = styled.img`
  display: block;
  margin-left: auto;
  margin-right: auto;
  width: 100%;
`;

const StyledText = styled.p`
  text-align: center;
  margin-top: 5px;
  margin-bottom: 40px;
  font-family: ${props => props.theme.fonts.medium};
  color: ${props => props.theme.colors.light};
`;

export { StyledWrapper, StyledImg, StyledText };
